export default function deviceSupported() {
	if (/iPhone/.test(navigator.platform)) {
		// https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_js_api/checking_for_apple_pay_availability
		if (window.ApplePaySession) {
			if (!window.ApplePaySession.canMakePayments()) return false;
		}

		// supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
		const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
		const version = v ? [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)] : [0, 0, 0, 0];
		return version[0] >= 9;
	}
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && navigator.platform == "MacIntel";
}
